module.exports = __webpack_public_path__ + "images/external_images/img/500x500/img3.jpg";